import type { GameResult, GameResultsLookup } from './types';

export class ArrayGameResultsLookup implements GameResultsLookup {
  private readonly games: GameResult[];

  constructor(games: GameResult[]) {
    this.games = games;
  }

  getGamesBetween(team1: string, team2: string): GameResult[] {
    return this.games.filter(g =>
      (g.homeTeam === team1 && g.awayTeam === team2) ||
      (g.homeTeam === team2 && g.awayTeam === team1),
    );
  }

  getGamesForTeam(team: string): GameResult[] {
    return this.games.filter(g => g.homeTeam === team || g.awayTeam === team);
  }
}
